import { cn } from "@/lib/utils";

interface OnlineDotProps {
  isOnline: boolean;
  className?: string;
}

export function OnlineDot({ isOnline, className }: OnlineDotProps) {
  return (
    <span
      className={cn(
        "rounded-full flex-shrink-0",
        isOnline ? "bg-green-500" : "bg-slate-400",
        className ?? "inline-block w-2.5 h-2.5"
      )}
      title={isOnline ? "Online" : "Offline"}
    />
  );
}
